import React from 'react';
import styled from 'styled-components';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { TextInlineSkin } from '@origin-digital/style-guide';
import { StepIconSvgs } from './icons';

const SvgImageCurrent = styled(TextInlineSkin)`
  width: 100%;
  height: 100%;
  margin-top: -14px;
  margin-right: 20px;
`;

const SvgImageFuture = styled(TextInlineSkin)`
  width: 100%;
  height: 100%;
`;

const OriginStepIconHorizontal = (props: StepIconProps) => {
  return props.icon === 1 ? (
    <SvgImageCurrent
      color="green"
      dangerouslySetInnerHTML={{
        __html: StepIconSvgs.currentStepSvg
      }}
    />
  ) : (
    <SvgImageFuture
      color="green"
      dangerouslySetInnerHTML={{
        __html: StepIconSvgs.futureStepSvg
      }}
    />
  );
};

export default OriginStepIconHorizontal;
